import { render, staticRenderFns } from "./DreamBooks.vue?vue&type=template&id=ce5e06ee&scoped=true&"
import script from "./DreamBooks.vue?vue&type=script&lang=js&"
export * from "./DreamBooks.vue?vue&type=script&lang=js&"
import style0 from "./DreamBooks.vue?vue&type=style&index=0&id=ce5e06ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5e06ee",
  null
  
)

export default component.exports